<template>
  <div class="order-info">
    <div class="order-container">
      <div class="order-detail">
        <div class="order-detail-item flex-between">
          <span>{{ letter.v3ItemPrice }}</span>
          <span class="price" v-if="openShoppingCart && this.isCart"
            >{{ cartTotalPrice }} {{ currency }}</span
          >
          <span class="price" v-else>{{ transMount }} {{ currency }}</span>
        </div>
        <div
          class="order-detail-item flex-between"
          :class="{ disable: !curPayType.coupon }"
          @click="toggleCouponPopup"
        >
          <div class="coupon-box">
            <span>{{ letter.v3SelectCoupon }}</span>
            <div class="coupon-tag">{{ couponTagTex }}</div>
          </div>
          <span
            class="price coupon flex-center"
            :class="{ active: paytypeActiveCouponId }"
            @click="onPriceCouponClick"
          >
            - {{ activePaytypeCouponReductPrice }} {{ currency }}
            <Icon class="price-icon" name="right" />
          </span>
        </div>
        <div class="order-detail-item flex-between" v-if="showStaticTaxRow">
          <span>{{ letter.v3Tax }}</span>
          <span class="price">{{ curTax }} {{ currency }} </span>
        </div>
        <div
          v-if="isTaxCollapsible && taxExpanded"
          class="tax-collapsible is-expanded"
        >
          <div class="tax-collapsible-inner">
            <div
              class="order-detail-item flex-between tax-row"
              @click="collapseTaxDetail"
            >
              <span>{{ letter.v3Tax }}</span>
              <span class="price">{{ curTax }} {{ currency }} </span>
            </div>
          </div>
        </div>
        <div class="order-detail-item flex-between">
          <span>{{ letter.v3Total }}</span>
          <span
            class="total"
            :class="{ 'is-pretax': isPretaxTotal }"
            v-if="openShoppingCart && this.isCart"
            >{{ displayTotalPrice }} {{ currency }}
          </span>
          <span v-else class="total" :class="{ 'is-pretax': isPretaxTotal }"
            >{{ displayTotalPrice }} {{ currency }}
          </span>
        </div>
        <div
          v-if="showCollapsedTaxHint"
          class="tax-not-included tax-not-included--after-total"
          @click="expandTaxDetail"
        >
          <span class="tax-not-included-text">{{
            letter.v3TaxNotIncluded
          }}</span>
          <span class="tax-not-included-icon" aria-hidden="true">i</span>
        </div>
      </div>
    </div>
    <Toast :text="paytypeToastText" />
  </div>
</template>

<script>
import coupon from '@mixins/officialTopupNew/coupon';
import product from '@mixins/officialTopupNew/product';
import zipcode from '@mixins/officialTopupNew/zipcode';
import cartAddAndDetail from '@mixins/officialTopupNew/cartAddAndDetail';
import paytypeToast from '@mixins/officialTopupNew/paytypeToast';
import Toast from '@components/officialTopupNew/common/Toast.vue';
import { mapGetters, mapState } from 'vuex';
import { popupType, clickButton } from '@plugins/biPoint/_configWebstoreV35';
import { MODIFY_TAX } from '@store/officialTopupNew';
export default {
  name: 'OrderInfo',
  mixins: [coupon, product, zipcode, cartAddAndDetail, paytypeToast],
  components: { Toast },
  props: {
    curProduct: {
      type: Object,
      default: () => {}
    },
    curPayType: {
      type: Object,
      default: () => {}
    },
    realTotalPrice: {
      type: [String, Number],
      default: 0
    },
    realCartTotalPrice: {
      type: [String, Number],
      default: 0
    },
    transMount: {
      type: [String, Number],
      default: 0
    },
    discountTransMount: {
      type: [String, Number],
      default: 0
    },
    shownTotalPrice: {
      type: [String, Number],
      default: ''
    },
    isTaxCollapsible: {
      type: Boolean,
      default: false
    },
    taxExpanded: {
      type: Boolean,
      default: false
    },
    showStaticTaxRow: {
      type: Boolean,
      default: false
    },
    isPretaxTotal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      letter: state => state.letter,
      isUidLogin: state => state.login.isUidLogin,
      lang: state => state.lang,
      curLocation: state => state.curLocation,
      zipCode: state => state.zipCode,
      curTax: state => state.curTax,
      paytype: state => state.paytype,
      hasLoadPaytype: state => state.hasLoadPaytype,
      openShoppingCart: state => state.page.openShoppingCart
    }),
    ...mapGetters(['isCart']),
    showCollapsedTaxHint() {
      return this.isTaxCollapsible && !this.taxExpanded;
    },
    hasAvailableCoupon() {
      return +this.curPayType.coupon === 1;
    },
    couponTagTex() {
      if (!this.hasAvailableCoupon) {
        return this.letter.v3NoCouponsAvaliable;
      }
      return this.paytypeActiveCouponId
        ? this.letter.v3CouponsSelected
        : this.letter.v3ClickSelectCoupon;
    },
    displayTotalPrice() {
      if (
        this.isTaxCollapsible &&
        this.shownTotalPrice != null &&
        this.shownTotalPrice !== ''
      ) {
        return this.shownTotalPrice;
      }
      if (this.openShoppingCart && this.isCart) {
        return this.realCartTotalPrice;
      }
      return this.realTotalPrice;
    },
    getRefreshTax() {
      const {
        cartTotalPrice,
        cartDiscountTransMount,
        discountTransMount,
        zipCode
      } = this;
      return {
        cartTotalPrice,
        cartDiscountTransMount,
        discountTransMount,
        zipCode
      };
    },
    currency() {
      return this.curPayType ? this.curPayType.show_currency : '';
    }
  },
  watch: {
    getRefreshTax: {
      immediate: true,
      deep: true,
      handler(newVal) {
        const totalPrice =
          this.openShoppingCart && this.isCart
            ? this.cartTotalPrice
            : this.discountTransMount;

        const discountPrice =
          this.openShoppingCart && this.isCart
            ? this.cartDiscountTransMount
            : this.discountTransMount;

        if (
          this.hasLoadPaytype &&
          this.curLocation === 'US' &&
          newVal.zipCode &&
          totalPrice
        ) {
          this.getCurrentTax({
            zipCode: newVal.zipCode,
            amount: this.paytype.coupon ? discountPrice : totalPrice,
            currency: this.currency
          });
        } else if (totalPrice === 0) {
          this.$store.commit(MODIFY_TAX, 0);
        }
      }
    }
  },
  methods: {
    onPriceCouponClick(event) {
      if (this.hasAvailableCoupon) return;
      event.stopPropagation();
      this.showPaytypeToast(this.letter.v3NoCouponsAvaliable);
    },
    expandTaxDetail() {
      if (!this.isTaxCollapsible || this.taxExpanded) return;
      this.$emit('expand-tax');
    },
    collapseTaxDetail() {
      if (!this.taxExpanded) return;
      this.$emit('collapse-tax');
    },
    toggleCouponPopup() {
      // 之前很坑的逻辑，如果不支持优惠券的渠道，不是清空列表，而是不显示入口，v3设置点击无效
      if (!this.curPayType.coupon) return;
      this.togglePaytypeCouponPopup();
    },
    postOrder() {
      this.$emit('postOrder');
    },
    cancelChooseCoupon() {
      clickButton({
        btnName: 'cancel_choose_coupon',
        locationKey: popupType.paytypeCouponPopup
      });
      this.hidePaytypeCouponPopup();
      this.updatePaytypeActiveCouponId('');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';
.order-info {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  background: $moduleBackgroundColor;
  font-size: 0;
}

.order-container {
  display: flex;
  justify-content: space-between;
  position: relative;
  box-sizing: border-box;
  padding: 30px 20px;
  width: 100%;
}

.order-detail {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-right: 10px;
  line-height: 1.5;
  .order-detail-item {
    position: relative;
    font-size: 26px;
    font-weight: bold;
    cursor: pointer;

    .coupon-box {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      max-width: 70%;
      .coupon-tag {
        flex: 1;
        padding: 0 10px;
        border: 1px solid $themeColor;
        border-radius: 10px;
        font-size: 22px;
        font-weight: normal;
        color: $themeColor;
      }
    }
    .cancel-icon {
      width: 30px;
      height: 30px;
      cursor: pointer;
      margin-right: 10px;
    }
    .price {
      color: #333;
      &-icon {
        color: #333333;
        position: absolute;
        right: -30px;
        width: 30px;
        height: 30px;
      }

      &.active {
        color: $themeColor;
      }
    }
    .total {
      font-size: 30px;
      color: $themeColor;
      font-weight: bold;
      transition: color 280ms ease;

      &.is-pretax {
        color: #555;
      }
    }

    &.disable {
      cursor: not-allowed;
    }
  }
  .order-detail-item + .order-detail-item,
  .tax-collapsible + .order-detail-item {
    margin-top: 30px;
  }

  .tax-row {
    margin-top: 30px;
  }
}

.tax-collapsible {
  display: grid;
  grid-template-rows: 0fr;
  pointer-events: none;
  transition: grid-template-rows 320ms cubic-bezier(0.22, 0.61, 0.36, 1);

  &.is-expanded {
    grid-template-rows: 1fr;
    pointer-events: auto;

    .tax-row {
      opacity: 1;
      transform: translateY(0);
      transition-delay: 40ms;
    }
  }
}

.tax-collapsible-inner {
  min-height: 0;
  overflow: hidden;
}

.tax-row {
  opacity: 0;
  transform: translateY(-6px);
  transition: opacity 260ms ease,
    transform 300ms cubic-bezier(0.22, 0.61, 0.36, 1);
}

.tax-not-included {
  display: flex;
  /* rtl:ignore */
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
  font-size: 22px;
  font-weight: normal;
  line-height: 1.4;
  color: #9aa3a0;
  cursor: pointer;
  user-select: none;

  &--after-total {
    margin-top: 4px;
    padding: 8px 0;
  }
}

.tax-not-included-icon {
  box-sizing: border-box;
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border: 1px solid currentColor;
  border-radius: 50%;
  font-size: 16px;
  font-style: italic;
  font-weight: 600;
  line-height: 1;
}

#ssr-page.landscape {
  .order-container {
    padding: 20px;
  }
  .order-detail {
    .order-detail-item {
      font-size: 18px;

      .coupon-box {
        .coupon-tag {
          font-size: 16px;
        }
      }

      .total {
        font-size: 22px;
      }
    }
    .order-detail-item + .order-detail-item,
    .tax-collapsible + .order-detail-item,
    .tax-row {
      margin-top: 14px;
    }

    .tax-not-included {
      margin-top: 2px;
      padding: 4px 0;
      font-size: 16px;
    }

    .tax-not-included-icon {
      width: 16px;
      height: 16px;
      font-size: 12px;
    }
  }
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
}
</style>
